import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledCloseIcon,
  StyledDialogContent,
  StyledDialogActions,
  StyledButton,
  StyledAgentButton,
  StyledGrid,
  StyledDivider
} from "./styled";

export const Alert = ({
  type,
  details = "",
  handleClose,
  isOpen,
  handleConfirm,
  percentage = 0,
  progressLabel = "",
  isAgent = false
}) => {
  return (
    <StyledDialog
      disableBackdropClick
      disableEscapeKeyDown
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
    >
      <StyledDialogTitle id="draggable-dialog-title">
        {type === "PROGRESS" ? <div></div> : <StyledCloseIcon />}
      </StyledDialogTitle>
      {!!details && <StyledDialogContent>{details}</StyledDialogContent>}

      <StyledDivider />
      <StyledDialogActions>
        {type === "PROGRESS" ? (
          <StyledGrid item xs={12} className={cx("btnContainer", "ml0")}>
            <StyledButton
              onClick={handleConfirm}
              color="primary"
              variant="contained"
              className={cx("actionButton", "ml0")}
            >
              Yes
            </StyledButton>
          </StyledGrid>
        ) : (
          <>
            {isAgent ? (
              <StyledGrid item xs={12}>
                <StyledAgentButton onClick={handleConfirm} color="primary" variant="contained">
                  Continue
                </StyledAgentButton>
              </StyledGrid>
            ) : (
              <StyledGrid item xs={12} className={cx("btnContainer", "ml0")}>
                <StyledButton
                  onClick={handleConfirm}
                  color="primary"
                  variant="contained"
                  className="actionButton"
                >
                  Continue
                </StyledButton>
              </StyledGrid>
            )}
          </>
        )}
      </StyledDialogActions>
    </StyledDialog>
  );
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  details: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  percentage: PropTypes.number,
  progressLabel: PropTypes.string,
  isAgent: PropTypes.bool
};
